import AuthLayout from '@/layouts/AuthLayout';
import { SelfServiceGate } from '@/lib/self-service/components/SelfServiceGate';
import { SelfServicePasswordContent } from '@/lib/self-service/components/SelfServicePasswordContent';

export default function SetPasswordPage() {
  return (
    <SelfServiceGate requireAuth>
      <AuthLayout title='Create a password'>
        <SelfServicePasswordContent />
      </AuthLayout>
    </SelfServiceGate>
  );
}
